import React, { Component } from 'react';

/** UI Kit */
import { TxtTitle1, TxtDefault } from '@atresmedia/intranet-texts';

/** Core */
import BoxInside from '../../../core/BoxInside';
import Label from '../../../core/Label';
import Input from '../../../core/Input';
import Buttons from '../../../core/Buttons';
import Icon from '../../../core/Icon';
import Loading from '../../../core/Loading';

/** Styles */
import { StyledPayrrollIncidence, StyledPayrrollMsj } from './style';

import { Ok, Exclamation } from '../../../../../assets/images/index';

class PayrrollIncidence extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sent: false, // true: E-mail sent
      loading: false, // waiting response
      success: false // true: success, false: error
    };
  }

  senEmail = e => {
    e.preventDefault();

    this.setState({
      sent: true,
      loading: true
    });
  };

  render() {
    const { sent, success, loading } = this.state;

    return (
      <BoxInside>
        <StyledPayrrollIncidence>
          <TxtTitle1>Buzón de Atención al Empleado. Nóminas</TxtTitle1>
          <p className="text mb-30">
            Si tienes alguna duda respecto a la nómina, rellena el formulario.
          </p>
          <form>
            <Label label="Asunto *" htmlFor="asunto" className="mb-5" />
            <Input id="asu  nto" name="asunto" className="mb-10" />
            <Label
              label="Introduzca el texto *"
              htmlFor="desc"
              className="mb-5"
            />
            <Input multiline id="desc" name="desc" className="mb-15" />

            <StyledPayrrollMsj sent={sent} loading={loading}>
              {sent && !loading && (
                <TxtDefault
                  className={success === true ? `form-success` : `form-error`}
                >
                  <Icon
                    size="m"
                    svg={success === true ? Ok : Exclamation}
                    color={success === true ? `success` : `error`}
                    className="mr-10 pt-10"
                  />
                  {success === true
                    ? `La incidencia se envío correctamente.`
                    : `Error: No se pudo enviar la incidencia.`}
                </TxtDefault>
              )}

              <Buttons
                secondary
                className="fr"
                onClick={e => this.senEmail(e)}
                type="submit"
              >
                Enviar
              </Buttons>
            </StyledPayrrollMsj>
            {loading && (
              <Loading className="payrroll-loading" txt="Enviando email" />
            )}
          </form>
        </StyledPayrrollIncidence>
      </BoxInside>
    );
  }
}

export default PayrrollIncidence;
